import React from 'react'
import styled from 'styled-components'
import { NavLink } from 'react-router-dom';
import { Image, Snip, getSnip } from 'launchpad';
import theme from 'styles/theme.js';

const TestimonialsContainer = styled.div`
  padding-top: 50px;
  padding-bottom: 50px;
  h3 {
    color: initial;
    margin-bottom: 20px;
  }
  quoteblock {
    quotes: "“" "”" "‘" "’";
    color: initial;
    >div {
      :before,
      :after {
        display: inline-block;
      }
      :before {
        content: open-quote;
      }
      :after {
        content: close-quote;
      }
    }
  }
  cite {
    color: ${theme.colors.blue.dark};
    >div {
      :before {
        display: inline;
        content: "— ";
      }
    }
  }
  .carousel-control-prev-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23646f79' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
  }

  .carousel-control-next-icon {
      background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23646f79' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
  }
`;

export default class Testimonials extends React.Component {
  render() {
    return <TestimonialsContainer>
      <div className="container">
        <h3 class="col-xs-12 text-center"><Snip name="testimonials-heading" page={this.props.page} /></h3>

        <div id="reviewCarousel" class="carousel slide" data-ride="carousel" data-interval="7000">
          <div class="carousel-inner text-center">
            <div class="carousel-item active">
              <quoteblock><Snip name="testimonial-1-quote" page={this.props.page} /></quoteblock>
              <cite><Snip name="testmonial-1-attribution" page={this.props.page} /></cite>
            </div>
            <div class="carousel-item">
              <quoteblock><Snip name="testimonial-2-quote" page={this.props.page} /></quoteblock>
              <cite><Snip name="testmonial-2-attribution" page={this.props.page} /></cite>
            </div>
            <div class="carousel-item">
              <quoteblock><Snip name="testimonial-3-quote" page={this.props.page} /></quoteblock>
              <cite><Snip name="testmonial-3-attribution" page={this.props.page} /></cite>
            </div>
            <div class="carousel-item">
              <quoteblock><Snip name="testimonial-4-quote" page={this.props.page} /></quoteblock>
              <cite><Snip name="testmonial-4-attribution" page={this.props.page} /></cite>
            </div>
            <div class="carousel-item">
              <quoteblock><Snip name="testimonial-5-quote" page={this.props.page} /></quoteblock>
              <cite><Snip name="testmonial-5-attribution" page={this.props.page} /></cite>
            </div>
          </div>
          <a class="carousel-control-prev" href="#reviewCarousel" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#reviewCarousel" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </TestimonialsContainer >
  }
}
